import React from "react";
import styled from "styled-components";

export const Loading = () => <Wrapper>Loading...</Wrapper>;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 24px;
`;
